<footer class="app-footer">
  <span class="app-footer__brand">CASHALOG</span>
  @if (session.tenantDisplayName()) {
    <span class="app-footer__sep" aria-hidden="true">·</span>
    <span class="app-footer__tenant">{{ session.tenantDisplayName() }}</span>
  }
</footer>
